/* ---------------------------------------------------------------------------
   TRAWOC — discount badge placement

   The badge is rendered by its own block but belongs on the price line, which
   the theme owns. This moves it there and recalculates it when the shopper
   changes variant. Without this the badge still renders, just below the price.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function selectedVariantId(scope) {
    var input = scope.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  function render(cfg, variant) {
    if (!variant || !variant.compare || variant.compare <= variant.price) return null;
    var percent = Math.round(((variant.compare - variant.price) * 100) / variant.compare);
    if (percent < cfg.minPercent) return null;

    var value;
    if (cfg.display === 'amount') value = variant.amount;
    else if (cfg.display === 'both') value = percent + '% · ' + variant.amount;
    else value = percent + '%';

    return cfg.label.replace('{value}', value);
  }

  function init(root) {
    if (root.dataset.twSavingReady === '1') return;
    root.dataset.twSavingReady = '1';

    var badge = root.querySelector('[data-tw-saving-badge]');
    var cfgEl = root.querySelector('[data-tw-saving-config]');
    if (!badge) return;

    var scope = root.closest('.main-product') || document;
    var priceRow = scope.querySelector('.main-product-price');

    /* Move onto the price line. */
    if (priceRow) priceRow.appendChild(badge);

    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    function sync() {
      var id = selectedVariantId(scope);
      if (!id || !cfg.variants[id]) return;
      var text = render(cfg, cfg.variants[id]);
      if (text) {
        badge.textContent = text;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    sync();

    /* The theme rewrites the price block on variant change; watch that
       rather than guessing at the theme's own event names. */
    if (priceRow && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; sync(); });
      }).observe(priceRow, { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() { document.querySelectorAll('[data-tw-saving]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
})();
